import { render, staticRenderFns } from "./InfoQuestionType.vue?vue&type=template&id=01f28b88&scoped=true"
import script from "./InfoQuestionType.vue?vue&type=script&lang=js"
export * from "./InfoQuestionType.vue?vue&type=script&lang=js"
import style0 from "./InfoQuestionType.vue?vue&type=style&index=0&id=01f28b88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f28b88",
  null
  
)

export default component.exports